export const APP_META = {
  TITLE: "枫上雾棋的日志",
};
